export type AiSummaryTakeawayItem = {
  title: string;
  text: string;
  points?: string[];
};

export type AiSummaryTakeaway = {
  overallPicture: string;
  highlightsSummary: AiSummaryTakeawayItem[];
  lowlightsSummary: AiSummaryTakeawayItem[];
};

export type AiSummaryMetric = {
  name: string;
  title: string;
  bullets: string[];
  scorePercent?: number;
  scoreCategory?: string;
  value?: string | number;
  unit?: string;
  measurements?: AiSummaryMeasurement[];
  showMeasurementTable?: boolean;
  interpretation?: AiSummaryInterpretation;
};

export type AiSummaryMeasurement = {
  value: number;
  dateCreated: string;
};

export type AiSummaryInterpretation = "Decreasing" | "Increasing" | "Stable";

export type AiSummarySystem = {
  name: string;
  score?: number;
  scoreCategory?: string;
  highlights: AiSummaryMetric[];
  lowlights: AiSummaryMetric[];
};

export type AiSummaryRecommendationDetail = {
  label: string;
  value: string;
};

export type AiSummaryRecommendationItem = {
  title: string;
  description: string;
  details: AiSummaryRecommendationDetail[];
};

export type AiSummaryRecommendationKey =
  | "exercise"
  | "nutrition"
  | "lifestyle"
  | "longevity_treatments"
  | "supplements"
  | "ivs"
  | "pharmaceuticals"
  | "pharmaceutical_ivs";

export type AiSummaryRecommendationValue =
  | string
  | string[]
  | AiSummaryRecommendationItem[];

export type AiSummaryRecommendations = Partial<
  Record<AiSummaryRecommendationKey, AiSummaryRecommendationValue>
>;

export type AiSummaryTrainingDay = {
  weekday: string;
  activity: string;
  subtype?: string;
};

export type AiSummaryNutritionDay = {
  fatGrams?: number;
  carbsGrams?: number;
  proteinGrams?: number;
  caloricBurnKcal?: number;
  caloricIntakeKcal?: number;
};

export type AiSummaryNutrition = {
  workoutDays?: AiSummaryNutritionDay;
  nonWorkoutDays?: AiSummaryNutritionDay;
};

export type AiSummaryResponse = {
  keyTakeaway: AiSummaryTakeaway;
  highlights: AiSummarySystem[];
  lowlights: AiSummarySystem[];
  trainingPlan: AiSummaryTrainingDay[];
  nutrition: AiSummaryNutrition;
  recommendations: AiSummaryRecommendations;
  disclaimer: string;
};

export const AI_SUMMARY_SERVICE_ORDER: AiSummaryRecommendationKey[] = [
  "longevity_treatments",
  "supplements",
  "ivs",
  "pharmaceuticals",
  "pharmaceutical_ivs",
];

export const AI_SUMMARY_RECOMMENDATION_ORDER: AiSummaryRecommendationKey[] = [
  "exercise",
  "nutrition",
  "lifestyle",
  ...AI_SUMMARY_SERVICE_ORDER,
];
